import { render, staticRenderFns } from "./InfoUserModal.vue?vue&type=template&id=cbafe5f2&scoped=true"
import script from "./InfoUserModal.vue?vue&type=script&lang=js"
export * from "./InfoUserModal.vue?vue&type=script&lang=js"
import style0 from "./InfoUserModal.vue?vue&type=style&index=0&id=cbafe5f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbafe5f2",
  null
  
)

export default component.exports